const endPoints = {
  links: "/https://storage-fe.fastraffic.io/homeworks/links",
};

export { endPoints };
